import firebase from '@/firebase'

const state = {
    scoreboard: [],
    scoreboardFetched: false,
}

const getters = {
    getScoreboard: state => state.scoreboard,
    isScoreboardFetched: state => state.scoreboardFetched,
}

const mutations = {
    setScoreboard: (state, payload) => state.scoreboard = payload,
    switchScoreboardFetched: state => state.scoreboardFetched = !state.scoreboardFetched,
    resetScoreboard: state => {
        state.scoreboardFetched = false;
        state.scoreboard = []
    }
}

const actions = {
    fetchScoreboard: async ({ commit, rootState: { auth: { userDetails: { grade } } } }) => {
        const scoreboard = await firebase
            .firestore()
            .collection('users')
            .where('grade', '==', grade)
            .where('searchListed', '==', true)
            .orderBy('points', 'desc')
            .limit(10)
            .get()
        const tempArr = []
        scoreboard.forEach(r => tempArr.push(r.data()))
        commit('setScoreboard', tempArr);
        commit('switchScoreboardFetched');
    }
}

export default {
    state, getters, actions, mutations
}